module.exports = __webpack_public_path__ + "img/network.c5488d51.png";